import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import Loading from '../common/Loading';
import campaignService from '../../services/campaign.service';

function TemplateSms() {
    const { templateId } = useParams();
    const [template, setTemplate] = useState(null);
    const [isLoading, setIsLoading] = useState(templateId !== 'new');
    const { register, handleSubmit, reset } = useForm();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        category: 'NEWSLETTER',
    });

    useEffect(() => {
        if (templateId === 'new') {
            const newData = {
                id: null,
                type: 'SMS',
                name: '',
                preview: '',
                isActive: '1',
                contentPath: '',
            };
            setTemplate(newData);
            reset(newData);
            setFormData({ category: 'NEWSLETTER' });
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        campaignService
            .getTemplateById(templateId)
            .then((res) => {
                const data = {
                    ...res.data,
                    isActive: res.data.isActive ? '1' : '0',
                };
                setTemplate(data);
                reset(data);
                setFormData({ 
                    category: res.data.category || 'NEWSLETTER' 
                });
            })
            .catch((err) => {
                console.error(err);
                toast.error('Failed to load template.', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
            .finally(() => setIsLoading(false));
    }, [templateId, reset]);

    const onSubmit = (submitData) => {
        const payload = {
            type: 'SMS',
            name: submitData.name,
            preview: submitData.preview,
            contentPath: submitData.contentPath,
            isActive: submitData.isActive === '1' || submitData.isActive === true,
            category: formData.category,
        };

        const request =
            templateId === 'new'
                ? campaignService.addUpdateTemplate(payload)
                : campaignService.updateTemplate(templateId, payload);

        request
            .then((res) => {
                toast.success('Template saved.', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                reset(res.data);
                setTemplate(res.data);
                navigate('/campaign');
            })
            .catch(() => {
                toast.error('Error saving template.', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    };

    return (
        <div className="container container-xxl">
            <div className="pagetitle d-flex justify-content-between">
                <h1>SMS Template</h1>
            </div>

            <div className="card shadow-sm mt-4">
                <div className="card-body pt-4">
                    {template && (
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row g-3 mb-4">
                                <div className="col-md-3">
                                    <label className="form-label small text-muted">Template ID</label>
                                    <div className="form-control-plaintext fw-medium">
                                        {template?.id || 'New'}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small text-muted">Status</label>
                                    <select className="form-select" {...register('isActive')}>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Template Name</label>
                                    <input
                                        type="text"
                                        {...register('name')}
                                        placeholder="Enter template name"
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            <div className="row g-3 mb-4">
                                <div className="col-md-9">
                                    <label className="form-label small text-muted">SMS Content</label>
                                    <textarea
                                        {...register('contentPath')}
                                        placeholder="Enter your SMS message content here..."
                                        className="form-control"
                                        rows="8"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small text-muted">Category</label>
                                    <select
                                        className="form-select"
                                        value={formData.category}
                                        onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                    >
                                        <option value="NEWSLETTER">Newsletter</option>
                                        <option value="BLAST">Blast</option>
                                    </select>
                                    <label className="form-label small text-muted mt-3">Preview Image Path</label>
                                    <input
                                        type="text"
                                        {...register('preview')}
                                        placeholder="Image path"
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 pt-3 border-top">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => navigate('/campaign')}
                                >
                                    <i className="bi bi-arrow-left me-1"></i>
                                    Back
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    <i className="bi bi-save me-1"></i>
                                    Save Template
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>

            {isLoading && <Loading />}
        </div>
    );
}

export default TemplateSms;
